/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ManifestExtensions } from '../Utils/Constants';
import Emitter from '../Utils/Emitter';
/**
 * @class
 * @description Vhs tech (VideoJs) js loader class. It receives Vhs instance to listen,
 * intercept and modify the requests if needed.
 * @exports LoaderVhs
 */
export default class LoaderVhs extends Emitter {
    /**
     * Constructs vhs loader object
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor() {
        super();
        //return;
        window['videojs'].Vhs.xhr = (options, callback) => {
            this.requestProcessor(options, callback);
            return {
                abort: () => { },
                addEventListener: (e, c) => {
                    this.on(e, c);
                },
                removeEventListener: (e, c) => this.off(e, c)
            };
        };
    }
    /**
     * Load method called by vhs when requests a url load.
     * Decides what to do checking the type of the request (manifest or segment).
     * It requests manifests normally, and for segments it uses the loader object.
     * @param {Object} options Request options.
     * @param {Object} callback Request callback.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    requestProcessor(options, callback) {
        let isManifest = false;
        ManifestExtensions.forEach((ext) => {
            isManifest = isManifest || options.uri.indexOf(ext) >= 0;
        });
        LoaderVhs._engine.request(new URL(options.uri), true, [
            (e) => {
                const response = {
                    body: e.data,
                    headers: e.headers,
                    method: 'GET',
                    statusCode: 200,
                    url: options.uri
                };
                callback(null, response);
                this.emit('loadend', response, 'target');
            }
        ], options.headers, undefined, !isManifest);
    }
}
